import React, { useEffect, useState, useRef } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import BobLoadingMask from '../../../../components/BobLoadingMask';
import DeleteCoreEntityModal from '../../Modals/DeleteCoreEntityModal';
import SystemContextMenu from './SystemContextMenu';

import { process as kendoProcess } from '@progress/kendo-data-query';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { calculateMinColumnWidths } from '../../../../helpers/calculateMinColumnWidths';

import * as K2ACoreActions from '../../../../actions/k2aCoreActions';
import { kendoGridInlineStyling } from '../../../../helpers/kendoGridInlineStyleHelper';
import * as classes from '../EntitiesPage.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const CoreSystemTable = ({
    activeNavCompany,
    activeNavSite,
    bobLoading,
    deleteCoreSystem,
    systems,
    systemsMeta,
    fetchCoreSystems,
    refreshTab,
    setRefreshTab,
    searchTerm,
    setCoreSystem,
    view,
    workbookModeEnabled,
    ...props
}) => {

    const [dataState, setDataState] = useState(initialDataState);
    const [deleteSystemModalOpen, setDeleteSystemModalOpen] = useState(false);
    const [selectedSystem, setSelectedSystem] = useState({});
    const [pageable] = useState({ pageSizes: true });
    const [systemNameColumnWidth, setEquipmentNameColumnWidth] = useState(450);
    const [take, setTake] = useState(10);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setEquipmentNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'name', 450, true));
    }, [windowSize]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init = async () => {
            await fetchCoreSystems(activeNavSite.id, { page: 1, limit: dataState.take });
        };
        if (activeNavCompany.id && activeNavSite.id && systemsMeta.site !== activeNavSite.id) init();
    }, [activeNavSite]);

    useEffect(() => {
        const refresh = async () => {
            setRefreshTab(view);

            await fetchCoreSystems(activeNavSite.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });

            setRefreshTab('');
        };

        if (refreshTab) refresh();
    }, [refreshTab]);
    
    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <SystemContextMenu
                    dataItem={props.dataItem}
                    setCoreSystem={setCoreSystem}
                    setDeleteSystemModalOpen={setDeleteSystemModalOpen}
                    setSelectedSystem={setSelectedSystem}
                />
            </td>
        );
    };

    const renderSystemTypeCell = props => {
        const systemType = props.dataItem.systemType.name;

        return (
            <td>
                {systemType}
            </td>
        );
    };

    const handleDeleteSystem = async () => {
        await deleteCoreSystem(selectedSystem.id);
        await fetchCoreSystems(activeNavSite.id, { page: 1, limit: dataState.take, searchFilter: searchTerm });
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    return (
        <React.Fragment>
            <style>
                { kendoGridInlineStyling }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(systems, dataState)}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    filterable={workbookModeEnabled}
                    pageable={pageable}
                    reorderable
                >
                    {
                        bobLoading.includes('FetchCoreSystems') || isEmpty(systemsMeta) || refreshTab === 'Site System' ?
                            <GridNoRecords>
                                Loading systems
                            </GridNoRecords>
                            :
                            <GridNoRecords>
                                No systems found
                            </GridNoRecords>

                    }
                    <Column
                        field="name"
                        title="System"
                        id={'systemColumn'}
                        width={systemNameColumnWidth}
                    />
                    <Column
                        field="client.name"
                        title="Client"
                        id={'clientColumn'}
                        width={200}
                    />
                    <Column
                        field="site.name"
                        title="Site"
                        id={'siteColumn'}
                        width={200}
                    />
                    <Column
                        field="systemType.name"
                        title="System Type"
                        id={'systemTypeColumn'}
                        cell={renderSystemTypeCell}
                        width={200}
                    />
                    <Column
                        field=""
                        locked={true}
                        sortable={false}
                        filterable={false}
                        title=""
                        width={80}
                        cell={actionsCell}
                    />
                </Grid>
                {
                    deleteSystemModalOpen ?
                        <DeleteCoreEntityModal
                            entity={{ ...selectedSystem, type: 'System' }}
                            handleDeleteEntity={handleDeleteSystem}
                            toggleModalOpen={setDeleteSystemModalOpen}
                        />
                        :
                        null
                }
                {
                    bobLoading.includes('FetchCoreSystems') || isEmpty(systemsMeta) || refreshTab === 'Site System' ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    activeNavSite:    state.bob.activeNavSite,
    bobLoading:       state.bob.bobLoading,
    systems:          state.k2aCore.systems,
    systemsMeta:      state.k2aCore.systemsMeta
});

const mapDispatchToProps = ({
    ...K2ACoreActions
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreSystemTable);
